function normalize(event) {
    let normalized;
    let delta = event.wheelDelta;
    let scroll =
        (window.pageXOffset || document.scrollLeft) -
            (document.clientLeft || 0) || 0;

    if (delta) {
        normalized = delta % 120 == 0 ? delta / 120 : delta / 12;
    } else {
        delta = event.deltaY || event.detail || 0;
        normalized = -(delta % 3 ? delta * 10 : delta / 3);
    }

    return normalized;
}

export default normalize;
